<template>
  <div class="hris-page hris-home-page">
    <div class="hris-page-inner">
      <div class="hris-home-logo-wrap">
        <img width="360" class="hris-home-logo" src="../assets/sgcc-black.png" alt="">
      </div>

      <div class="hris-grid hris-home-grid">
        <router-link v-for="(module, index) in uniqueMenu" v-bind:key="index" :to="'/'+module.code">
          <div class="hris-content-card hris-home-tile" @click="clickSelectModule(module.name)">
            <div class="hris-content-card-body hris-home-tile-body">
              <i class="fa fa-3x hris-home-tile-icon" :class="module.iconClass"></i>
              <h6 class="hris-home-tile-name">{{module.name}}</h6>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <!-- START:: ANNOUNCEMENT MODAL -->
    <q-dialog v-model="announcement">
      <div class="hris-modal hris-modal-lg">
        <div class="hris-modal-header">
          <h2 class="hris-modal-title">{{latestAnnouncement.subject}}</h2>
        </div>
        <div class="hris-modal-body">
          <p v-if="latestAnnouncement.full_message == ''">{{latestAnnouncement.message}}</p>
          <p v-else>{{latestAnnouncement.full_message}}</p>
          <q-img v-if="latestAnnouncement.file_type == 'image/jpeg'" :src="latestAnnouncement.attachmentLink" style="width: 100%"></q-img>
        </div>
        <div class="hris-modal-footer">
          <a
            v-if="latestAnnouncement.attachment != null"
            class="hris-home-attachment-link"
            href="#"
            @click="dlAttacment(latestAnnouncement.attachmentLink,latestAnnouncement.attachment)"
          >
            <i class="fa fa-paperclip"></i>
            Download Attachment
          </a>
          <q-btn unelevated class="hris-q-outline" label="Close" v-close-popup></q-btn>
        </div>
      </div>
    </q-dialog>
    <!-- END:: ANNOUNCEMENT MODAL -->
  </div>
</template>
<script>
import axios from 'axios';
export default {
  name: "Home",
  data() {
    return {
      announcement: false,
      latestAnnouncement: [],
      attachementLink: '',
      allowedMenu: [],
      uniqueMenu: [] //change to modules if you want to show all
    }
  },

  mounted: function() {
    this.setMenu();
  },

  created: function() {
    this.displayData();
  },

  methods: {
    //START:: ANNOUNCEMENT
    displayData: function() {
      axios.create({
          baseURL: this.apiUrl,
          headers: {
            'Authorization': `Bearer ${this.token}`
          }
        })
        .get(`getAnnouncementList`)
        .then((res) => {
          this.latestAnnouncement = res.data.data.pub[0];
          //this.attachementLink = this.latestAnnouncement.attachmentLink;
         // this.readAnnouncement();

        })
    },
    //update read_announcement
    readAnnouncement: function() {
      let formData = new FormData();
      formData.append("id", this.latestAnnouncement.id);

      axios.create({
          baseURL: this.apiUrl,
          headers: {
            'Authorization': `Bearer ${this.token}`
          }
        })
        .post(`announcement/read`, formData)
        .then((res) => {
          //console.log(res.data.data)
          if (res.data.data == 'read') {
            this.announcement = false;
          } else {
            this.announcement = true;
          }
        })
    },
    //download attachment
    dlAttacment: function(url, filename) {
      //alert(filename)
      axios({
        url: url,
        method: 'GET',
        responseType: 'arraybuffer',
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', filename);
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    },
    //END:: ANNOUNCEMENT

    setMenu: function() {
      const menuList = this.modules; //get menu list
      const allowedMenu = this.userData; //get allowed menu in token
      const roleId = Number(this.userData.role_id);
      let isAdmin = roleId === 0 || roleId === 1;
      let newApplicant = (this.userData.username == 'NewApplicant') ? true : false; //For New Applicants

      if (isAdmin) {
        this.allowedMenu = menuList
      } else if (newApplicant) {
        for (let i in menuList) {
          for (let key in allowedMenu.modules) {
            if (menuList[i]['allowedmenu'] === allowedMenu.modules[key]['name']) {
              this.allowedMenu.push(menuList[i]);
            }
          }
        }
      } else {
        for (let i in menuList) {
          if (menuList[i]['allowedmenu'] == 'forms' || menuList[i]['allowedmenu'] == 'leaves' || menuList[i]['allowedmenu'] == 'announcement' || menuList[i]['allowedmenu'] == 'payslip') { //make form and leaves default
            this.allowedMenu.push(menuList[i]);
          }
          for (let key in allowedMenu.modules) {
            if (menuList[i]['allowedmenu'] === allowedMenu.modules[key]['name']) {
              this.allowedMenu.push(menuList[i]);
            }
          }
        }
      }

      var unique = this.allowedMenu.filter(function(elem, index, self) { //remove duplicate menu
        return index === self.indexOf(elem);
      })

      this.uniqueMenu = unique;
    },

    clickSelectModule: function() {
      return true;
    }

  }
};
</script>
<style scoped>
.hris-home-page {
  min-height: 100vh;
}

.hris-home-logo-wrap {
  text-align: center;
  margin-bottom: 32px;
}

.hris-home-logo {
  max-width: 360px;
  width: 100%;
}

.hris-home-grid {
  max-width: 960px;
  margin: 0 auto;
}

.hris-home-tile {
  cursor: pointer;
  text-decoration: none;
  height: 100%;
}

.hris-home-tile-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 14px;
  padding: 32px 22px;
}

.hris-home-tile-icon {
  color: var(--hris-accent);
  transition: transform 0.28s;
}

.hris-home-tile:hover .hris-home-tile-icon {
  transform: rotate(-10deg);
}

.hris-home-tile-name {
  margin: 0;
  line-height: 1.35;
  font-size: 1rem;
  font-weight: 600;
  color: var(--hris-text);
}

.hris-home-attachment-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--hris-accent);
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: none;
  margin-right: auto;
}

.hris-home-attachment-link:hover {
  color: var(--hris-accent-hover);
  text-decoration: underline;
}
</style>
